import React from 'react'
import { useHistory } from 'react-router-dom'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as AlmacenCrud from 'services/almacen.service'

const portletBreadcrumbs = [{ name: 'Almacenes' }]
const tableHeaderRows = [{ label: 'NOMBRE' }, { label: 'SEDE' }, { label: 'DESCRIPCION' }, { label: '', width: 60 }]

const ListaAlmacenesPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const history = useHistory()
  const tablaRef = React.useRef(null)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.ALMACENES_NUEVO}`)
  }, [history])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.ALMACENES_NUEVO}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await AlmacenCrud.eliminarAlmacen(_id)
        .then(() => {
          __zariContext.snack('success', 'Almacen eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover tabIndex={-1} key={row._id}>
        <Table.Cell>{row.nombre}</Table.Cell>
        <Table.Cell>{row.sedeNombre}</Table.Cell>
        <Table.Cell>{row.descripcion}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEditar, clickEliminar]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Almacenes' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
        <Portlet.Body>
          <Table.ServerSide ref={tablaRef} useNest={true} url='/almacenes' headRows={tableHeaderRows} rowTemplate={rowTemplate} />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ListaAlmacenesPage
